import { Theme } from "@mui/material/styles";

// MUI stacks its modal layer (1300) BELOW its snackbar layer (1400), so anything that must
// stay visible over a snackbar is pushed above it by hand — this app does that in ~20 places
// as `theme.zIndex.snackbar + N`.
//
// `BillingDialog` is one of them, and it is the one that bites: it hosts whole screens (the
// HCFA claim wizard, the payment form), so those screens open dialogs of their own. A nested
// dialog left on the default modal layer renders BEHIND the billing dialog and behind its
// opaque backdrop — invisible and unclickable, while still taking the focus trap, so the
// screen underneath looks frozen rather than broken. That is how a claim upload with issues
// reported by Claim.MD came to look like a submit button that did nothing.
//
// Both sides of the relationship live here so they cannot drift apart again.
export const getBillingDialogZIndex = (theme: Theme) =>
  theme.zIndex.snackbar + 3;

export const getNestedInBillingDialogZIndex = (theme: Theme) =>
  getBillingDialogZIndex(theme) + 1;

// The layer for any popup opened while a BillingDialog is up — a select menu, a date-picker
// popper, an autocomplete listbox that portals. It clears the nested dialogs too, so it serves
// both a popup inside one of them (the claim-scrub Sex dropdown, SN-19630) and the hosted
// screen's own popups (the claim wizard's selects and date pickers, DEV-3137).
export const getPopupInNestedBillingDialogZIndex = (theme: Theme) =>
  getNestedInBillingDialogZIndex(theme) + 1;
